<table mat-table class="mat-table-selection" [dataSource]="dataSource" matSort matSortActive="{{sortColumn}}"
  (matSortChange)="sortChanged($event)" [matSortDirection]="sortDirection">

  <ng-container matColumnDef="noRecord">
    <td class="no-record" [colSpan]="this.columnsToDisplay.length" mat-footer-cell *matFooterCellDef>
      <sc-dictionary-label dictionaryKey="shared.tmc-table.nodata"></sc-dictionary-label>
    </td>
  </ng-container>

  <ng-container matColumnDef="scope">
    <th mat-header-cell mat-sort-header *matHeaderCellDef>
      <sc-dictionary-label dictionaryKey="tmc-yard.entity.vehicle.scope"></sc-dictionary-label>
    </th>
    <td mat-cell class="text-selection" [ngClass]="{'selected': selectedListEntry == vehicle}"
      *matCellDef="let vehicle">
      <app-transport-scope-icon [scope]="vehicle.scope"></app-transport-scope-icon>
    </td>
  </ng-container>

  <ng-container matColumnDef="carrier">
    <th mat-header-cell mat-sort-header *matHeaderCellDef>
      <sc-dictionary-label dictionaryKey="tmc-yard.entity.vehicle.carrier"></sc-dictionary-label>
    </th>
    <td mat-cell class="text-selection" [ngClass]="{'selected': selectedListEntry == vehicle}"
      *matCellDef="let vehicle"> {{vehicle.carrier}} </td>
  </ng-container>

  <ng-container matColumnDef="identifier">
    <th mat-header-cell mat-sort-header *matHeaderCellDef>
      <sc-dictionary-label dictionaryKey="tmc-yard.entity.vehicle.numberplate"></sc-dictionary-label>
    </th>
    <td mat-cell class="text-selection" [ngClass]="{'selected': selectedListEntry == vehicle}"
      *matCellDef="let vehicle"> {{vehicle.identifier}} </td>
  </ng-container>

  <ng-container matColumnDef="name">
    <th mat-header-cell mat-sort-header *matHeaderCellDef>
      <sc-dictionary-label dictionaryKey="tmc-yard.entity.vehicle.name"></sc-dictionary-label>
    </th>
    <td mat-cell class="text-selection" [ngClass]="{'selected': selectedListEntry == vehicle}"
      *matCellDef="let vehicle"> {{vehicle.name}} </td>
  </ng-container>

  <ng-container matColumnDef="currentStation">
    <th mat-header-cell mat-sort-header *matHeaderCellDef>
      <sc-dictionary-label dictionaryKey="tmc-yard.entity.vehicle.current-station"></sc-dictionary-label>
    </th>
    <td mat-cell class="text-selection" [ngClass]="{'selected': selectedListEntry == vehicle}"
      *matCellDef="let vehicle"> {{vehicle.currentStation}} </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>

  <tr mat-row *matRowDef="let vehicle; columns: columnsToDisplay" [attr.data-vehicle-id]="vehicle.id"
    [ngClass]="getRowStyles(vehicle)" (click)="toggleSelection(vehicle)"></tr>

  <tr [class.hide]="dataSource.data.length > 0" mat-footer-row *matFooterRowDef="['noRecord']"></tr>
</table>
